module.exports = __webpack_public_path__ + "img/the mansions two beauties.b1d5015c.png";